export class AudioSystem {
  private ctx: AudioContext | null = null;
  private master: GainNode | null = null;
  private muted = false;

  private ensure(): void {
    if (this.ctx) return;
    const Ctx = window.AudioContext || (window as unknown as { webkitAudioContext: typeof AudioContext }).webkitAudioContext;
    this.ctx = new Ctx();
    this.master = this.ctx.createGain();
    this.master.gain.value = 0.22;
    this.master.connect(this.ctx.destination);
  }

  resume(): void {
    this.ensure();
    void this.ctx?.resume();
  }

  setMuted(m: boolean): void {
    this.muted = m;
  }

  play(type: 'pickup' | 'sell' | 'deposit' | 'plant' | 'honey' | 'milestone' | 'click' | 'deny'): void {
    if (this.muted) return;
    this.ensure();
    if (!this.ctx || !this.master) return;
    if (this.ctx.state === 'suspended') void this.ctx.resume();

    const t = this.ctx.currentTime;
    const o = this.ctx.createOscillator();
    const g = this.ctx.createGain();
    o.connect(g);
    g.connect(this.master);

    const map: Record<string, { f: number; f2?: number; d: number; type: OscillatorType }> = {
      pickup: { f: 520, f2: 780, d: 0.08, type: 'triangle' },
      sell: { f: 440, f2: 880, d: 0.12, type: 'sine' },
      deposit: { f: 300, f2: 420, d: 0.1, type: 'square' },
      plant: { f: 360, f2: 540, d: 0.14, type: 'sine' },
      honey: { f: 600, f2: 480, d: 0.1, type: 'triangle' },
      milestone: { f: 523, f2: 784, d: 0.28, type: 'sine' },
      click: { f: 240, d: 0.05, type: 'square' },
      deny: { f: 160, f2: 120, d: 0.12, type: 'sawtooth' },
    };

    const p = map[type]!;
    o.type = p.type;
    o.frequency.setValueAtTime(p.f, t);
    if (p.f2) o.frequency.exponentialRampToValueAtTime(p.f2, t + p.d);
    g.gain.setValueAtTime(0.0001, t);
    g.gain.exponentialRampToValueAtTime(0.35, t + 0.01);
    g.gain.exponentialRampToValueAtTime(0.0001, t + p.d);
    o.start(t);
    o.stop(t + p.d + 0.02);
  }

  dispose(): void {
    void this.ctx?.close();
    this.ctx = null;
    this.master = null;
  }
}
